import React, { FC } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import { QuestionnaireDocumentDownload } from './QuestionnaireDocumentDownload';
import { Attachment } from '../../../../interfaces/Attachment';

interface Props {
  attachments: Attachment[];
  operationId?: string;
  emailReceiver?: string;
  onDocumentAction?: (type: 'view' | 'download' | 'send', attachment: Attachment, receiver?: string) => void;
}
export const QuestionnaireSampleContract: FC<Props> = ({ attachments, operationId, emailReceiver, ...props }) => {
  const sampleContract = attachments?.find((attachment) => attachment.fileName?.startsWith('mustervertrag_'));
  return (
    <QuestionnaireForm title={'Mustervertrag'}>
      {
        sampleContract &&
        <QuestionnaireDocumentDownload
          attachment={sampleContract}
          operationId={operationId}
          emailReceiver={emailReceiver}
          onDocumentAction={props.onDocumentAction}
        />
      }
    </QuestionnaireForm>
  )
}
